import styled from 'styled-components';

import { media } from '@/Shared/theme';

export const StyledCourseCard = styled.div<{ $maxHeight: number }>`
	background-color: #ededed;
	border-radius: 6px;
	border: 4px solid #ededed;
	box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
	flex-shrink: 0;
	margin-bottom: var(--spacing-4);
	margin-right: var(--spacing-4);
	max-height: ${(props) => `${props.$maxHeight}px`};
	overflow: hidden;
	position: relative;
	scroll-snap-align: start;
	width: min(350px, calc(100vw - 2rem));

	${media.smallScreen} {
		overflow: auto;
		width: 400px;
	}

	&:after {
		bottom: 0;
		content: '';
		height: 50px;
		left: 0;
		right: 0;
		position: absolute;
		width: 100%;
	}

	&.open-card {
		max-height: 70vh;
		overflow-y: auto;
	}

	&.last-collapsed {
		background-color: #c3c1bd;
	}

	${media.smallScreen} {
		overflow: hidden;
	}

	&.selected-in-search {
		border: 4px solid var(--org-color);
	}

	&:empty {
		padding: 0;
	}

	p:empty {
		margin-bottom: var(--spacing-6);
	}

	&.spacer {
		background: var(--neutral-50);
		border: 1px dashed rgba(0, 0, 0, 0.3);

		* {
			display: none;
		}
	}

	.edit-icon {
		display: none;

		${media.smallScreen} {
			display: block;
		}
	}

	.content {
		display: flex;
		flex-direction: column;
		height: 100%;
		padding-right: var(--spacing-4);
		padding: var(--spacing-4);
		width: 100%;
		position: relative;
	}

	ul,
	ol {
		display: block;
		margin-block-start: 1em;
		margin-block-end: 1em;
		margin-inline-start: 0px;
		margin-inline-end: 0px;
		padding-inline-start: 40px;
		unicode-bidi: isolate;
	}

	ol {
		list-style-type: decimal;
	}

	ul {
		list-style-type: disc;
	}

	time {
		color: var(--body-text);
		font-size: 1.2rem;
	}

	.media-link {
		color: var(--org-color);
		display: inline-flex;

		svg {
			align-self: center;
		}
	}
`;

export const StyledCourseCardHeader = styled.div`
	box-shadow: 0px 2px 0px -1px rgba(50, 50, 50, 0.1);
	margin-bottom: var(--spacing-4);
	padding-bottom: var(--spacing-2);

	.spacer & {
		display: none;
	}
`;
